import { extractFlowIdFromUrl } from "@/core/auth/flow-id-from-request";
import { LogFields, LogLevel, flowIdForLog } from "@/datadog/events";
import { getViewId } from "@/datadog/view-id";
import { VIEW_ID_HEADER } from "@/shared/request-ids";

export interface ClientLogPayload extends Omit<LogFields, "flowId"> {
	level: LogLevel;
	message: string;
	flowId?: string;
	requestBody?: unknown;
	context?: unknown;
	error?: unknown;
}

function serializeError(err: unknown): { message: string; stack?: string } {
	if (!err) return { message: "Unknown error" };
	if (err instanceof Error) {
		return { message: err.message, stack: err.stack };
	}
	return { message: String(err) };
}

function flowIdFromPath(): string | undefined {
	if (typeof window === "undefined") return undefined;
	return extractFlowIdFromUrl(window.location.href);
}

export async function sendClientLog({ error, ...payload }: ClientLogPayload) {
	try {
		const body = JSON.stringify({
			...payload,
			flowId: flowIdForLog(payload.flowId ?? flowIdFromPath()),
			error: error && serializeError(error),
		});

		const viewId = getViewId();
		await fetch("/api/log", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...(viewId ? { [VIEW_ID_HEADER]: viewId } : {}),
			},
			body,
		});
	} catch (e) {
		console.error("Failed to fire client log", e);
	}
}
